<template>
  <v-card width="450" class="pa-3">
    <v-card-title >
      <v-flex column>
        <h2>Crear</h2>
        <h3>Nueva Misión Base</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-flex pl-5 justify-end>
        <v-btn
          color="primary"
          depressed
          small
          fab
          :disabled="$loading.isLoading('creatingBaseMission')"
          @click="cancel"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-flex>
    </v-card-title>
    <v-card-text>
      <v-form
        ref="formCreateMisionBase"
        v-model="valid"
        lazy-validation
        @submit.prevent
      >
        <!-- BASE MISSION NAME -->
        <v-text-field
          v-model="missionName"
          label="Nombre"
          color="white"
          required
          box
          :rules="missionNameRules" 
        ></v-text-field>
        <!-- AGENCY -->
        <v-flex pb-3>
          <h3>Misión de la agencia</h3>
          {{ agenciesMap.get(selections[0].userAgencyId).name }}
        </v-flex>
        <!-- <div>
          <v-select
            v-model="agency"
            :items="agenciesBase"
            item-text="name"
            item-value="id"
            box
            label="Agencias"
          ></v-select>
        </div> -->
        <!-- ZONES AND/OR DESCRIPTION -->
        <div>
          <!-- OPTIONS -->
          <h3>¿Se pueden asignar vehículos directamente a esta misión?</h3>
          <v-radio-group
            v-model="descriptionOption"
            class="mb-3"
            row
            required
            :rules="descriptionOptionsRules"
          >
            <v-radio
              v-for="(n, index) in descriptionOptions"
              :key="index"
              :label="n"
              :value="n"
              color="primary"
              @change="descriptionOptionChange"
            ></v-radio>
          </v-radio-group>
          <!-- DESCRIPTION -->
          <v-textarea
            v-if="descriptionOption === 'Si' || (descriptionOption === 'No' && baseZone !== undefined)"
            v-model="description"
            box
            maxlength="200"
            counter
            name="description"
            label="Descripción de la misión"
            :rules="descriptionRules"
          ></v-textarea>
          <!-- BASE ZONES LIST -->
          <div v-if="descriptionOption === 'No'" class="caption">*Opcional</div>
          <v-select
            v-if="descriptionOption !== ''"
            v-model="baseZone"
            :items="zonesList"
            box
            label="Tipo de Zona"
            required
            clearable
            :rules="descriptionOption === 'Si' ? zoneRules : []"
            @click:clear="baseZoneClear"
          ></v-select>
          <!-- ZONES IN LIST -->
          <v-autocomplete
            v-if="baseZone !== undefined"
            v-model="zonesIn"
            :items="baseZoneSelected"
            item-text="name"
            item-value="id"
            clearable
            :multiple="!(descriptionOption === 'No' && baseZone !== undefined)"
            box
            label="Zonas"
            required
            :rules="!(descriptionOption === 'No' && baseZone !== undefined)
              ? zonesInRules 
              : zonesInRulesAlt
            "
            @click:clear="!(descriptionOption === 'No' && baseZone !== undefined)
              ? zonesIn = []
              : zonesIn = ''
            "
          ></v-autocomplete>
        </div>
        <div v-if="descriptionOption === 'Si'">
          <!-- INCLUDED VEHICLES -->
          <h3 :class="showDependecyGroupAlert ? 'error-message' : ''">
            Dependencia/Grupo de vehículos que pueden ser asignados a la misión:
          </h3>
          <div v-if="selections.length > 0">
            <!-- {{
              agenciesMap.get(agenciesMap.get(agencyIdSelected).superParentId).name
            }}
            <br />
            {{ agenciesMap.get(agencyIdSelected).name }} -->
            <v-treeview
              v-bind="selected"
              item-key="id"
              activatable
              active-class="primary"
              :items="agenciesTreeFiltered"
              :active.sync="selectedInAgency"
              :return-object="true"
            ></v-treeview>
            <!-- ALERT ERROR -->
            <transition name="bounce">
              <div v-if="showDependecyGroupAlert" class="caption error-message error-line">
                Seleccione una Dependencia/Grupo
              </div>
            </transition>
          </div>
          <!-- EXCLUDED VEHICLES -->
          <h3 v-if="selectedInAgency.length > 0">
            ¿Se requiere excluir algún grupo de vehículos?
          </h3>
          <v-radio-group
            v-if="selectedInAgency.length > 0"
            v-model="excludeVehiclesOption"
            row
          >
            <v-radio
              v-for="(n, index) in excludeVehiclesOptions"
              :key="index"
              :label="n"
              :value="n"
              color="primary"
              @change="excludeVehiclesOptionChange"
            ></v-radio>
          </v-radio-group>
          <v-treeview
            v-if="excludeVehiclesOption === 'Si'"
            v-bind="selectedExclude"
            item-key="id"
            activatable
            active-class="primary"
            :items="agenciesTreeFilteredExclude"
            :active.sync="disabledAgencies"
            :return-object="true"
          ></v-treeview>
          <div v-if="excludeVehiclesOption === 'Si' && agenciesTreeFilteredExclude.length === 0">
            De acuerdo a la selección previa no hay grupo o grupos que se puedan seleccionar para excluir.
          </div>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-flex>
        <v-btn
          color="error"
          :disabled="$loading.isLoading('creatingBaseMission')"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn 
          color="primary"
          :loading="$loading.isLoading('creatingBaseMission')"
          @click="createBaseMissionIn"
        >
          Crear
        </v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { areasMixin } from '../mixins/areasMixin'

export default {
  name: 'base-missions-form',
  mixins: [areasMixin],
  props: {
    selections: {
      type: Array,
      default: [],
      required: false
    },
    templatesUp: {
      type: Object,
      default: {},
      required: true
    }
  },
  data() {
    return {
      valid: true,
      missionName: '',
      missionNameRules: [
        v => !!v || 'El Nombre es requerido',
        v =>
          (v && v.length >= 3) ||
          'Un Nombre válido debe contener por lo menos 3 letras',
        v => this.validateMissionName(v) || 'Nombre ya en uso'
      ],
      agency: null,
      descriptionOption: '',
      descriptionOptions: [
        'Si',
        'No'
      ],
      descriptionOptionsRules: [
        v => !!v || 'Seleccione una opción'
      ],
      description: '',
      descriptionRules: [
        v => !!v || 'La descripción es requerida',
        v =>
          (v && v.length >= 12) ||
          'Una Descripción válida debe contener por lo menos 12 letras'
      ],
      zonesList: [
        { text: 'Municipios', value: 'municipality' },
        { text: 'Comunas', value: 'communesAlt' },
        { text: 'Barrios', value: 'neighborhoods' },
        { text: 'Distritos Policía MEVAL', value: 'districts' },
        { text: 'Estaciones Policía MEVAL', value: 'stations' },
        { text: 'Cuadrantes Policía MEVAL', value: 'quadrants' },
        { text: 'Cuerpo Bomberos Medellín', value: 'firefighters' },
        { text: 'Otro', value: 'fences' }
      ],
      baseZone: undefined,
      zonesIn: undefined,
      zoneRules: [
        v => !!v || 'Seleccione una zona'
      ],
      zonesInRules: [
        v => v.length > 0 || 'Seleccione una o varias zonas'
      ],
      zonesInRulesAlt: [
        v => !!v || 'Seleccione una zona'
      ],
      excludeVehiclesOption: '',
      excludeVehiclesOptions: [
        'Si',
        'No'
      ],
      disabledAgencies: [],
      match: false,
      agenciesFiltered: [],
      agenciesFilteredExclude: [],
      selectedInAgency: [],
      matchExclude: false,
      missionNames: [],
      indexes: [],
      agenciesTreeClone: [],
      agenciesFilteredExclude2: [],
      matchExclude2: false,
      showDependecyGroupAlert: false
    }
  },
  // watch: {
  //   selected(newValue, oldValue) {
  //     console.log('selected WATCH:', newValue, oldValue)
  //     if ((newValue !== undefined && oldValue !== undefined) && newValue !== oldValue) {
  //       console.log('IN')
  //       let agenciesTreeExcludeTemp = []
  //       agenciesTreeExcludeTemp = this.recursiveSearchInExclude(this.agenciesTree)
  //       console.log('WATCH - EXCLUDE', agenciesTreeExcludeTemp)
  //       return agenciesTreeExcludeTemp[0].children
  //     }
  //   }
  //   // selected: 'recursiveSearchInExclude'
  // },
  computed: {
    ...mapGetters({
      firefighters: 'filters/getFirefighters',
      municipality: 'filters/getMunicipality',
      neighborhoods: 'filters/getNeighborhoods',
      communes: 'filters/getComunes',
      quadrants: 'filters/getQuadrants',
      stations: 'filters/getStations',
      districts: 'filters/getDistricts',
      fences: 'getGeofences',
      adminRole: 'auth/adminRole'
    }),
    ...mapGetters(['agenciesBase', 'agenciesMap', 'agenciesTree']),
    baseZoneSelected() {
      let result = this[this.baseZone]
      if (this.baseZone === 'fences' && this.adminRole !== null) {
        result = this[this.baseZone].filter(
          item => item.agencies[0] === this.selections[0].userAgencyId
        )
      }
      return result
    },
    selected() {
      this.excludeVehiclesOption = ''
      this.matchExclude = false
      if (!this.selectedInAgency.length) {
        return undefined
      }
      const selection = this.selectedInAgency
      console.log('selected COMPUTED', selection)
      this.showDependecyGroupAlert = false
      return selection
    },
    selectedExclude() {
      this.matchExclude2 = false
      if (!this.disabledAgencies.length) return undefined
      const selection = this.disabledAgencies
      console.log(selection)
      return selection
    },
    agenciesTreeFiltered() {
      console.log('AGENCY ID', this.selections[0].agencyId)
      // let agenciesTreeClone = []
      // if (this.selections[0].agencyId !== null) {
      console.log('agenciesTreeFiltered')
      // agenciesTreeClone = Object.assign({}, this.agenciesTree)
      // console.log('agenciesTreeClone', agenciesTreeClone)
      let agenciesTreeTemp = this.recursiveSearchIn(this.agenciesTreeClone)
      // }
      // Object.assign(agenciesTreeClone, agenciesTreeTemp)
      console.log('agenciesTreeTemp', agenciesTreeTemp)

      if (this.selections[0].disabledAgencies !== '') {
        const idDisabledAgency = Number(this.selections[0].disabledAgencies)
        console.log('idDisabledAgency', idDisabledAgency)
        this.recursiveSearchFilter(agenciesTreeTemp, idDisabledAgency)
        // console.log('INDEXES', this.indexes)
      }

      return agenciesTreeTemp
    },
    agencyIdSelected() {
      const result = this.selections[0].agencyId === null
        ? this.selections[0].userAgencyId
        : this.selections[0].agencyId
      // const result = this.agenciesBase.filter(item => item.id === selectionCompare)
      console.log(result)
      // const result = this.agenciesMap.get(selectionCompare).name
      // return result[0].name
      return result
    },
    agenciesTreeFilteredExclude() {
      console.log('AGENCY IN ID SELECTED', this.selectedInAgency[0].id)
      let agenciesTreeExcludeTemp = []
      const disabledAgencies = this.selections[0].disabledAgencies
      const disabledAgenciesCondition = disabledAgencies !== '' && disabledAgencies !== null
      const obj = disabledAgenciesCondition ? this.selectedInAgency : this.agenciesTreeClone
      console.log('disabledAgencies ?', disabledAgencies, disabledAgenciesCondition)
      // agenciesTreeExcludeTemp = disabledAgenciesCondition
      //   ? this.recursiveSearchFilterExclude(obj, disabledAgencies)
      //   : this.recursiveSearchInExclude(obj)
      agenciesTreeExcludeTemp = this.recursiveSearchInExclude(obj)
      console.log('EXCLUDE', agenciesTreeExcludeTemp)
      let result = agenciesTreeExcludeTemp[0].children

      if (disabledAgenciesCondition) {
        result = this.recursiveSearchFilterExclude(agenciesTreeExcludeTemp, disabledAgencies)
      }
      console.log('RESULT', result)
      // const result = disabledAgenciesCondition
      //   ? agenciesTreeExcludeTemp
      //   : agenciesTreeExcludeTemp[0].children
      return result
    }
  },
  methods: {
    ...mapActions(['createBaseMission']),
    descriptionOptionChange(value) {
      console.log('descriptionOptionChange', value)
      this.baseZone = undefined
      this.zonesIn = undefined
    },
    excludeVehiclesOptionChange(value) {
      console.log('excludeVehiclesOptionChange', value)
    },
    recursiveSearchIn(obj) {
      // let result = []
      for (const children in obj) {
        if (this.match) break

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === this.agencyIdSelected) {
            this.agenciesFiltered = []
            this.agenciesFiltered.push(obj[children])
            this.match = true
            console.log('BREAK')
            break
          } else this.recursiveSearchIn(obj[children])
        }
      }
      // for (let index = 0; index < obj.length; index++) {
      //   const element = obj[index]
      //   console.log('ELEMENT', element, element.id, this.selections[0].agencyId)
      //   if (element.id === this.selections[0].agencyId) {
      //     console.log('BREAK')
      //     result = element
      //     break
      //   } else if (element.children !== undefined && element.children.length > 0) {
      //     this.recursiveSearchIn(element.children)
      //   }
      // }
      console.log('RESULT', this.agenciesFiltered)
      return this.agenciesFiltered
    },
    recursiveSearchInExclude(obj) {
      // let result = []
      for (const children in obj) {
        if (this.matchExclude) break
        console.log('OBJ', obj)

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === this.selectedInAgency[0].id) {
            this.agenciesFilteredExclude = []
            this.agenciesFilteredExclude.push(obj[children])
            this.matchExclude = true
            console.log('BREAK')
            break
          } else this.recursiveSearchInExclude(obj[children])
        }
      }
      return this.agenciesFilteredExclude
    },
    cancel() {
      this.$emit('cancel')
    },
    async createBaseMissionIn() {
      if (this.$refs.formCreateMisionBase.validate()) {
        if (this.descriptionOption === 'Si' && !this.selected) {
          this.showDependecyGroupAlert = true
          return
        }
        console.log('Validated')
        let zonesInChecked = []
        if (Array.isArray(this.zonesIn)) { // This check the special case of SC & SJ in multiple zone in selection
          this.zonesIn.forEach(element => {
            const isArrayEl = Array.isArray(element)
            if (isArrayEl) {
              element.forEach(elementIn => {
                zonesInChecked.push(elementIn)
              })
            } else zonesInChecked.push(element)
            console.log('zonesInChecked', zonesInChecked)
          })
        } else { // This for the zone selection of only one polygon
          this.zonesIn === undefined
            ? zonesInChecked = []
            : zonesInChecked.push(this.zonesIn)
        }
        const payload = {
          name: this.missionName,
          agencyId: this.descriptionOption === 'Si'
            ? this.selectedInAgency[0].id
            : null,
          description: this.description,
          disabledAgencies: this.disabledAgencies.length === 0
            ? null
            : String(this.disabledAgencies.map(item => item.id)[0]),
          parentId: this.selections[0].baseMissionId,
          type: this.selections[0].type,
          userAgencyId: this.selections[0].userAgencyId,
          where: zonesInChecked
        }

        console.log('PAYLOAD:', payload)
        const response = await this.createBaseMission(payload)
        console.log('RESPONSE:', response)
        this.cancel()
        if (response) {
          console.log('OK')
          this.$emit('reload')
        } else {
          console.error('ERROR')
          alert('ERROR\n\nSe presentó un error al momento de crear la misión.\n\nPor favor intente de nuevo.\n\nSi el error persiste por favor contactar al administrador del sistema.')
        }
      }
    },
    getMissionNames(obj) {
      let missionNameTemp
      for (const children in obj) {
        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj.name) missionNameTemp = obj.name
          this.getMissionNames(obj[children])
        }
      }
      if (missionNameTemp !== undefined) this.missionNames.push(missionNameTemp)
    },
    validateMissionName(v) {
      let result = true
      for (let index = 0; index < this.missionNames.length; index++) {
        const element = this.missionNames[index]
        if (v === element) {
          result = false
          break
        }
      }
      return result
    },
    recursiveSearchFilter(obj, id) {
      // let result = []
      // console.log('------------------------------------------')
      // let index = 0
      let breakFromArray = false
      for (const children in obj) {
        // console.log('TYPE OF', typeof obj[children], obj[children])
        if (typeof obj[children] === 'object' && obj[children] !== null) {
          // console.log('IN', Array.isArray(obj[children]))
          if (Array.isArray(obj[children])) {
            // obj[children].forEach(element => {
            //   console.log('ELEMENT ID', element.id)
            // })
            // this.indexes.push(index)
            // index++
            for (let index = 0; index < obj[children].length; index++) {
              const element = obj[children][index]
              if (element.id === id) {
                // console.log('ELEMENT', element, element.id)
                obj[children].splice(index, 1)
                breakFromArray = true
                break
              }
            }
          }
          if (breakFromArray) {
            // console.log('recursiveSearchFilter BREAK', obj, obj[children])
            break
          } else this.recursiveSearchFilter(obj[children], id)
        }
      }
    },
    recursiveSearchFilterExclude(obj, id) {
      for (const children in obj) {
        if (this.matchExclude2) break
        console.log('OBJ', obj)

        if (typeof obj[children] === 'object' && obj[children] !== null) {
          if (obj[children].id === id) {
            this.agenciesFilteredExclude2 = []
            this.agenciesFilteredExclude2.push(obj[children])
            this.matchExclude2 = true
            console.log('BREAK')
            break
          } else this.recursiveSearchFilterExclude(obj[children], id)
        }
      }
      return this.agenciesFilteredExclude2
      // // let result = []
      // // console.log('------------------------------------------')
      // // let index = 0
      // let breakFromArray = false
      // for (const children in obj) {
      //   // console.log('TYPE OF', typeof obj[children], obj[children])
      //   if (typeof obj[children] === 'object' && obj[children] !== null) {
      //     // console.log('IN', Array.isArray(obj[children]))
      //     if (Array.isArray(obj[children])) {
      //       // obj[children].forEach(element => {
      //       //   console.log('ELEMENT ID', element.id)
      //       // })
      //       // this.indexes.push(index)
      //       // index++
      //       for (let index = 0; index < obj[children].length; index++) {
      //         const element = obj[children][index]
      //         if (element.id === id) {
      //           // console.log('ELEMENT', element, element.id)
      //           obj[children].splice(index, 1)
      //           breakFromArray = true
      //           break
      //         }
      //       }
      //     }
      //     if (breakFromArray) {
      //       // console.log('recursiveSearchFilter BREAK', obj, obj[children])
      //       break
      //     } else this.recursiveSearchFilterExclude(obj[children], id)
      //   }
      // }
    },
    baseZoneClear() {
      console.log('baseZoneClear')
      this.zonesIn = undefined
    }
  },
  created() {
    this.getMissionNames(this.templatesUp)
  },
  beforeMount() {
    this.agenciesTreeClone = JSON.parse(JSON.stringify(this.agenciesTree))
  }
}
</script>

<style lang="scss" scoped>
.error-message {
  color: #FF5252;
}
.error-line {
  border-top: 2px solid #FF5252;
}
.bounce-enter-active {
  animation: bounce-in .25s;
}
// .bounce-leave-active {
//   animation: bounce-in .1s reverse;
// }
@keyframes bounce-in {
  0% {
    transform: translateX(1em);
  }
  50% {
    transform: translateX(-1em);
  }
  100% {
    transform: translateX(1em);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BaseMissionsForm.vue